// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CostumeCheckBox-module__wrapper","checked":"CostumeCheckBox-module__checked"};